package ru.education.building.schedule.data.repositories

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.russhwolf.settings.ExperimentalSettingsApi
import com.russhwolf.settings.Settings
import com.russhwolf.settings.serialization.decodeValue
import com.russhwolf.settings.serialization.encodeValue
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.builtins.ListSerializer
import ru.education.building.schedule.data.datasources.ApiService
import ru.education.building.schedule.data.models.Misis
import ru.education.building.schedule.data.models.MisisGroups


class ScheduleRepository(private val api: ApiService, private val settings: Settings = Settings()) {
    companion object {
        private const val KEY_SELECTED_GROUP = "selected_group"
        private const val KEY_SELECTED_ID = "selected_id"
        private const val KEY_SCHEDULE_CACHE = "schedule_cache"
    }

    var selectedGroup by mutableStateOf(settings.getStringOrNull(KEY_SELECTED_GROUP))
        private set

    var selectedId by mutableStateOf(settings.getStringOrNull(KEY_SELECTED_ID))
        private set

    @OptIn(ExperimentalSerializationApi::class, ExperimentalSettingsApi::class)
    var cachedSchedule by mutableStateOf(
        settings.decodeValue(
            serializer = ListSerializer(Misis.serializer()),
            key = KEY_SCHEDULE_CACHE,
            defaultValue = emptyList()
        )
    )
        private set

    fun selectGroup(groupName: String) {
        selectedGroup = groupName
        settings.putString(KEY_SELECTED_GROUP, groupName)
    }

    fun selectId(id: String) {
        selectedId = id
        settings.putString(KEY_SELECTED_ID, id)
    }

    @OptIn(ExperimentalSerializationApi::class, ExperimentalSettingsApi::class)
    fun selectSchedule(scheduleList: List<Misis>) {
        cachedSchedule = scheduleList
        settings.encodeValue(
            serializer = ListSerializer(Misis.serializer()),
            key = KEY_SCHEDULE_CACHE,
            value = scheduleList
        )
    }

    suspend fun loadSchedule(id: String): List<Misis> = api.getSchedule(id)
    suspend fun loadGroup(): List<MisisGroups> = api.getGroup()
}